import React from 'react';
import { observer } from 'mobx-react-lite';
import { InputText, Select } from '@insurancemenu/imenu-components-lib';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { FormControl, StandardFormChangeEvent } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { createStyles } from './styles';
import { GROUP_INFO_FORM_TEST, PHYSICAL_ADDRESS_INFO_TEST } from '../constants';

interface PhysicalAddressInformationProps {
  city: FormControl<string>;
  street: FormControl<string>;
  street2: FormControl<string>;
  zip: FormControl<string>;
  state: FormControl<string>;
  county: FormControl<string>;
  countiesOptions: OptionType[];
  onChange: (e: StandardFormChangeEvent) => void;
}

const PhysicalAddressInformation: React.FC<PhysicalAddressInformationProps> = observer(
  ({ city, street, street2, zip, state, county, countiesOptions, onChange }) => {
    const classes = createStyles();
    return (
      <div data-test-id={PHYSICAL_ADDRESS_INFO_TEST}>
        <p className={classes.category}>Physical Address</p>
        <div className={classes.inputContainer}>
          <InputText
            label="City"
            name="city"
            value={city.value}
            onChange={onChange}
            validationMessage={city.unpassedValidationMsg || ''}
            validationPassed={!city.unpassedValidationMsg}
            className={classes.formInput}
            data-test-id={GROUP_INFO_FORM_TEST.city}
          />
          <InputText
            label="Street"
            name="street"
            value={street.value}
            onChange={onChange}
            validationMessage={street.unpassedValidationMsg || ''}
            validationPassed={!street.unpassedValidationMsg}
            className={classes.halfInputLayout}
            data-test-id={GROUP_INFO_FORM_TEST.street}
          />
          <InputText
            label="Street2"
            name="street2"
            value={street2.value}
            onChange={onChange}
            validationMessage={street2.unpassedValidationMsg || ''}
            validationPassed={!street2.unpassedValidationMsg}
            className={classes.halfInputLayout}
            data-test-id={GROUP_INFO_FORM_TEST.street2}
          />
          <InputText
            label="Zip Code"
            name="zip"
            onChange={onChange}
            value={zip.value}
            validationMessage={zip.unpassedValidationMsg || ''}
            validationPassed={!zip.unpassedValidationMsg}
            className={classes.thirdInputLayout}
            maxLength={5}
            data-test-id={GROUP_INFO_FORM_TEST.zip}
          />
          <InputText
            label="State"
            name="state"
            disabled
            value={state.value}
            validationMessage={state.unpassedValidationMsg || ''}
            validationPassed={!state.unpassedValidationMsg}
            className={classes.thirdInputLayout}
            data-test-id={GROUP_INFO_FORM_TEST.state}
          />
          <Select
            label="County"
            name="county"
            onChange={onChange}
            value={county.value}
            options={countiesOptions}
            validationMessage={county.unpassedValidationMsg || ''}
            validationPassed={!county.unpassedValidationMsg}
            className={classes.thirdInputLayout}
            data-test-id={GROUP_INFO_FORM_TEST.county}
          />
        </div>
      </div>
    );
  },
);

export default PhysicalAddressInformation;
